export default __webpack_public_path__ + "static/media/icon5white.ce0bafd7.svg";